module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notProductRelated":"No product assigned","propagateConflict":"Spreading will also modify other restaurant products that you do not have access to."},"es":{"notProductRelated":"No hay ningun producto asignado","propagateConflict":"Al propagar se modificaran tambien otros productos de restaurantes que no tienes acceso"}}')
  delete Component.options._Ctor
}
